import { action } from "satcheljs";
import { ShiftEditorViewStateSchema } from "../index";
import { Moment } from "moment";
import ISmartScheduleShiftEntity from "sh-models/shift/ISmartScheduleShiftEntity";

export const initializeLocalObservableSmartScheduleShift = action(
    'initializeLocalObservableSmartScheduleShift',
    (
        shiftEditorViewState: ShiftEditorViewStateSchema,
        shift: ISmartScheduleShiftEntity,
        startDate: Moment
    ) => {
        return ({
            shiftEditorViewState: shiftEditorViewState,
            shift: shift,
            startDate: startDate
        });
    }
);

export default initializeLocalObservableSmartScheduleShift;
